<template>
  <div class="landing_side loadOverlay" :style="appConfig.isQueueUpDomain ? 'display: block' : ''">
    <template v-if="!appConfig.isQueueUpDomain">
      <div
        v-for="(game, index) in listGame"
        :key="index"
        class="landing_side_item"
        style="padding-top: 10px"
      >
        <a
          :href="routePubgEventsFilter(game.alias)"
          style="cursor: pointer"
          :title="game.display_name ? game.display_name : null"
        >
          <img
            v-if="game.landing_icon"
            class="lazyload"
            :data-src="appConfig.content_cloud_front_f + '/' + game.landing_icon"
            style="width: 70px; height: 70px; object-fit: cover"
          >
          <img v-else :src="appConfig.content_cloud_front_f + '/' + game.event_icon" style="width: 70px; height: 70px; object-fit: cover">
        </a>
      </div>
    </template>
    <queueup-lhs-menu v-else-if="appConfig.isQueueUpDomain" />
    <!-- comment for GAME 8931  -->
    <!-- <template v-else>
      <template v-if="!isAuth">
        <div id="list_following" class="landing_side_item">
          <div class="landing_side_title">FOLLOWING</div>
          <a class="landing_add" href="#" style="display: flex;">
            <div class="landing_addline top" />
            <div class="landing_addline bot" />
            <div class="landing_addline left" />
            <div class="landing_addline right" />
            <div class="landing_addplus" />
          </a>
        </div>
      </template>
      <template v-else>
        <div class="landing_side_item">
          <div class="landing_side_title">FOLLOWED</div>
          <div id="list_followed">
            <a
              v-for="user in listFollowed"
              :key="user._id"
              class="landing_side_user"
              :href="routeProfileCheck(user.name)"
              :title="user.display_name"
            >
              <img
                v-if="!user.logo"
                class="lazyload"
                :data-src="appConfig.content_cloud_front + '/assets/' + appConfig.content_assets_version + '/placeholder-avatar.png'"
              >
              <img v-else class="lazyload" :data-src="user.logo">
            </a>
          </div>
        </div>
      </template>
    </template> -->
  </div>
</template>

<script>
import { Lazyload } from '../../../mixins/lazyload';
import { component } from '../../../mixins/component';
import { helper } from '../../../mixins/helper';
import { UserMixin } from '../../../mixins/user';
import { TwitchAPI } from '../../../api/twitch';
import { UserAPI } from '../../../api/user';
import { LandingAPI } from '../../../api/landing';
import Vue from 'vue';
require('../../../utils/facescroll');

export default {
  mixins: [Lazyload, component, helper, UserMixin, TwitchAPI, UserAPI, LandingAPI],
  data() {
    return {
      listGame: [],
      listFollowed: [],
    };
  },
  created() {
    if (!this.appConfig.isQueueUpDomain) {
      this.getListGameByOrder();
    }
  },
  methods: {
    async getListGameByOrder() {
      try {
        const res = await this.getListGameByOrderAPI();
        if (res.data.status === 0) {
          this.listGame = res.data.data;
          Vue.nextTick(() => {
            $('.landing_side').alternateScroll({ 'vertical-bar-class': 'bar-class', 'hide-bars': true });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    sortListFollowedByTotalFollower() {
      this.listFollowed.sort((a, b) => {
        return a.followers > b.followers ? 1 : (a.followers < b.followers ? -1 : 0);
      });
    },
  },
};
</script>
